export const TRAY = {
    Correspondence: "CORRESPONDENCE",
    EmailAttachment: "EMAIL ATTACHMENT",
} as const;
export type TRAY_NAMES = typeof TRAY[keyof typeof TRAY];
export const TRAY_OPTIONS: string[] = [...Object.values(TRAY)];
